import { Grid } from '@mui/material';
import colors from '../../theme/colors';
import * as T from '../Typography';
import Button from '../Button';
import warning from '../assets/warning.svg';

const errorDetails = `We encountered a technical issue while processing your request. Please
          try again. If that doesn't work, please contact support for
          assistance.`;

const handleRefresh = () => {
  window.location.reload();
};

const Error = ({
  errorTitle = 'Oops! Something went wrong',
  errorMsg = errorDetails,
  buttonLabel = 'Try again',
  buttonOnClick = () => handleRefresh()
}) => {
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: {
          xs: '100%',
          sm: '384px'
        }
      }}
      margin={'auto'}
    >
      <Grid
        container
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <img src={warning} alt="error" />
        <T.TextLargeBold
          mt="6"
          mb="2"
          ta="center"
          color={colors.neutral.shades.shade700}
        >
          {errorTitle}
        </T.TextLargeBold>
        <T.TextSmallRegular
          ta="center"
          mb={6}
          center
          color={colors.neutral.shades.shade600}
        >
          {errorMsg}
        </T.TextSmallRegular>
        <Button onClick={buttonOnClick}>{buttonLabel}</Button>
      </Grid>
    </Grid>
  );
};

export default Error;
